/**
 *  Date    : 2021/12/09
 *  Author  : weiLin
 *  Declare : 默认菜单
 */
import Utils from '@/utils/utils';
import PAGES from '../../constants/page';
import { isDevelopment } from '@/config';
// 图标
export const MENUS_ICON = {
  school: 'https://oss.5rs.me/oss/uploadfe/png/c0177de90f290634c26da9dd56a6f935.png',
  activity: 'https://oss.5rs.me/oss/uploadfe/png/b5b52ab07b81c5f01ad59a60d8a52382.png',
  home: 'https://oss.5rs.me/oss/uploadfe/png/18c9c19a645c67fdb9d46e16f76de5e2.png',
  arrow: 'https://oss.5rs.me/oss/uploadfe/png/bc6d2734a87e63ee11f933fb11fdcce4.png',
  banner: 'https://oss.5rs.me/oss/uploadfe/png/dc7f52d8050171b7f1795e82f664d14c.png',
  advertise: 'https://oss.5rs.me/oss/uploadfe/png/7f04482dc3effc1db7b12f7699401b01.png',
  order: 'https://file.5rs.me/oss/uploadfe/png/31f371725adca7717d9922836957c070.png',
  live: 'https://oss.5rs.me/oss/uploadfe/png/6c6bb56faa9d324d751c2cff0bd73be8.png',
  book: 'https://oss.5rs.me/oss/uploadfe/png/8c87e519b4aeefa2d047f3627632a1d5.png',
  bookSelect: 'https://oss.5rs.me/oss/uploadfe/png/e84e59e191c2dfa0f7adac54ad7531b6.png'
};

// 默认菜单
export const PRIVATE_DOMAIN_PERMISSIONS = [
  // {
  //   iconType: 'ic-guanli-out',
  //   iconTypeSelect: MENUS_ICON.bookSelect,
  //   id: 9,
  //   invalid: false,
  //   parentId: 0,
  //   name: '首页概览',
  //   path: PAGES.HOME
  // },
  // {
  //   iconType: MENUS_ICON.home,
  //   arrowIcon: MENUS_ICON.arrow,
  //   id: 1,
  //   invalid: false,
  //   parentId: 0,
  //   name: '仪表盘',
  //   path: PAGES.HOME,
  //   typeCode: 'HOME'
  // },
  {
    iconType: 'ic-kefu-out1',
    id: 4,
    invalid: true,
    parentId: 0,
    name: '智能客服',
    path: PAGES.META_PERSON
  },
  {
    id: 41,
    invalid: false,
    parentId: 4,
    name: '服务监控',
    path: PAGES.META_MONITOR,
    typeCode: 'BOOK'
  },
  {
    id: 42,
    invalid: false,
    parentId: 4,
    name: '话术配置',
    path: PAGES.META_VERBAL,
    typeCode: 'QRCODE'
  },
  {
    iconType: 'ic-xiandaizhishu',
    iconTypeSelect: MENUS_ICON.bookSelect,
    id: 5,
    invalid: false,
    parentId: 0,
    name: '现代纸书',
    defaultIndex: 1,
    collapse: true,
    path: PAGES.BOOK
  },
  // {
  //   iconType: 'ic-guanli-out',
  //   iconTypeSelect: MENUS_ICON.bookSelect,
  //   id: 8,
  //   invalid: false,
  //   parentId: 0,
  //   name: '智能作书',
  //   path: PAGES.MIND
  // },
  // {
  //   id: 81,
  //   invalid: false,
  //   parentId: 8,
  //   name: '智能工具',
  //   path: PAGES.MIND_TOOLS,
  //   typeCode: 'TOOL'
  // },
  // {
  //   id: 54,
  //   invalid: false,
  //   parentId: 5,
  //   name: '做书方案',
  //   path: PAGES.BOOK_SCHEME,
  //   typeCode: 'BOOK'
  // },
  {
    id: 51,
    invalid: false,
    parentId: 5,
    name: '创建书刊',
    path: PAGES.BOOK_CREATE,
    typeCode: 'BOOK'
  },
  {
    id: 51,
    invalid: true,
    parentId: 5,
    name: '从6.0选取书刊',
    path: PAGES.BOOK_SELECT,
    typeCode: 'BOOK'
  },
  {
    id: 52,
    invalid: false,
    parentId: 5,
    name: '书刊管理',
    path: PAGES.BOOK_MANAGE,
    typeCode: 'BOOK'
  },
  {
    id: 51,
    invalid: true,
    parentId: 5,
    name: '修改书刊',
    path: PAGES.BOOK_UPDATE,
    typeCode: 'BOOK'
  },
  {
    id: 53,
    invalid: true,
    parentId: 5,
    name: '二维码管理',
    path: PAGES.QRCODE_MANAGE,
    typeCode: 'BOOK'
  },
  {
    iconType: 'ic-yingyongziyuan',
    iconTypeSelect: MENUS_ICON.bookSelect,
    id: 10,
    invalid: false,
    parentId: 0,
    name: '做书资源',
    collapse: true,
    path: PAGES.RESOURCE
  },
  // {
  //   id: 101,
  //   invalid: false,
  //   parentId: 10,
  //   name: '应用中心',
  //   path: PAGES.RESOURCE_APP_CENTER,
  //   typeCode: 'RESOURCE'
  // },
  // {
  //   id: 102,
  //   invalid: false,
  //   parentId: 10,
  //   name: '我的应用',
  //   path: PAGES.RESOURCE_MY_APP,
  //   typeCode: 'RESOURCE'
  // },
  // {
  //   id: 103,
  //   invalid: false,
  //   parentId: 10,
  //   name: '我的作品',
  //   path: PAGES.RESOURCE_MY_PRODUCT,
  //   typeCode: 'RESOURCE'
  // },
  {
    id: 104,
    invalid: false,
    parentId: 10,
    name: '做书素材',
    path: PAGES.RESOURCE_MATERIAL,
    typeCode: 'RESOURCE'
  },
  {
    id: 105,
    invalid: false,
    parentId: 10,
    name: '超级作者',
    path: PAGES.RESOURCE_SUPER,
    typeCode: 'RESOURCE'
  },
  {
    id: 106,
    invalid: false,
    parentId: 10,
    name: '伴学工具',
    path: PAGES.RESOURCE_RAYS_TOOLS,
    typeCode: 'RESOURCE'
  },
  {
    id: 8,
    iconType: 'ic-AIzhushou1',
    invalid: false,
    parentId: 0,
    name: 'AI助手',
    collapse: true,
    path: PAGES.AI
  },
  {
    id: 80,
    invalid: false,
    parentId: 8,
    name: '创作看板',
    path: PAGES.AI_TOOLS
  },
  {
    id: 81,
    invalid: false,
    parentId: 8,
    name: '创作记录',
    path: PAGES.AI_HISTORY
  },
  {
    id: 82,
    invalid: true,
    parentId: 8,
    name: 'AI写作',
    path: PAGES.AI_COPYWRITE
  },
  {
    id: 83,
    invalid: true,
    parentId: 8,
    name: 'AI审读',
    path: PAGES.AI_SPEEDREADING
  },
  {
    id: 83,
    invalid: true,
    parentId: 8,
    name: 'AI画图',
    path: PAGES.AI_PAINTING
  },
  {
    id: 84,
    invalid: true,
    parentId: 8,
    name: 'AI有声书',
    path: PAGES.AI_TEXT2SPEECH
  },
  {
    iconType: 'ic-duzheyunying',
    id: 6,
    invalid: false,
    parentId: 0,
    name: '读者运营',
    path: PAGES.READERS,
    typeCode: 'BOOK'
  },
  {
    id: 61,
    invalid: true,
    parentId: 6,
    name: '读者管理',
    path: PAGES.READER_MANAGE,
    typeCode: 'BOOK'
  },
  {
    id: 64,
    invalid: false,
    parentId: 6,
    name: '读者问题反馈',
    path: PAGES.READER_FEEDBACK,
    typeCode: 'BOOK'
  },
  {
    id: 62,
    invalid: false,
    parentId: 6,
    name: '消息推送',
    path: PAGES.READER_MESSAGE,
    typeCode: 'BOOK'
  },
  {
    id: 63,
    invalid: true,
    parentId: 6,
    name: '公众号推送',
    path: PAGES.READER_MESSAGE_ADD,
    typeCode: 'BOOK'
  },
  {
    id: 65,
    invalid: false,
    parentId: 6,
    name: '企业微信',
    path: PAGES.READER_WECHAT,
    typeCode: 'BOOK'
  },
  {
    iconType: 'ic-shuzirenkanban',
    iconTypeSelect: MENUS_ICON.bookSelect,
    id: 7,
    invalid: false,
    parentId: 0,
    name: '数字人看板',
    path: PAGES.DATA_PANEL
  },
  // {
  //   id: 75,
  //   invalid: false,
  //   parentId: 7,
  //   name: '服务订购',
  //   path: PAGES.DATA_PANEL_DIGITAL_ORDER,
  //   typeCode: 'DATA_PANEL'
  // },
  {
    id: 71,
    invalid: false,
    parentId: 7,
    name: '数据总览',
    path: PAGES.DATA_PANEL_OVERVIEW,
    typeCode: 'DATA_PANEL'
  },
  {
    id: 72,
    invalid: false,
    parentId: 7,
    name: '会话分析',
    path: PAGES.DATA_PANEL_CONVERSATION,
    typeCode: 'DATA_PANEL'
  },
  {
    id: 73,
    invalid: false,
    parentId: 7,
    name: '交易分析',
    path: PAGES.DATA_PANEL_TRANSACTION,
    typeCode: 'DATA_PANEL'
  },
  {
    id: 74,
    invalid: false,
    parentId: 7,
    name: '书刊分析',
    path: PAGES.DATA_PANEL_BOOK_ANALYSIS,
    typeCode: 'DATA_PANEL'
  },
  // {
  //   iconType: 'ic-hongbangrenwu',
  //   iconTypeSelect: MENUS_ICON.bookSelect,
  //   id: 11,
  //   invalid: false,
  //   parentId: 0,
  //   name: '红榜任务',
  //   path: PAGES.HOME
  // },
  {
    iconType: 'ic-jintiaodan',
    iconTypeSelect: MENUS_ICON.bookSelect,
    id: 12,
    invalid: false,
    parentId: 0,
    name: '尽调单',
    path: PAGES.BASIC_BOOK_RESEARCH
  }
];

// 格式化配置路由
export default function setPermission(userInfo = {}, hasCompanyIp) {
  let [...routerPath] = PRIVATE_DOMAIN_PERMISSIONS;
  if(hasCompanyIp !== '1' && location.hostname !== 'rays7.raysgo.com' && !isDevelopment) {
    routerPath = routerPath.filter(v => (v.id !== 5 && v.parentId === 0) || ![0, 5].includes(v.parentId));
  }
  if(!userInfo.haveRays7) {
    routerPath = routerPath.filter(v => (v.id !== 7 && v.parentId === 0) || ![0, 7].includes(v.parentId));
  }
  return Utils.unFlatMap(routerPath);
}
